import React from "react";

/**
 * Tiny inline sparkline (SVG), zero deps.
 * values: number[], width/height in px.
 */
export default function Sparkline({ values, width = 120, height = 32, stroke = "#00FA9A", fill = "none" }) {
  const clean = (values || []).filter((v) => v !== null && v !== undefined && !Number.isNaN(v));
  if (clean.length < 2) {
    return <svg width={width} height={height} aria-hidden />;
  }
  const min = Math.min(...clean);
  const max = Math.max(...clean);
  const range = max - min || 1;
  const step = width / (clean.length - 1);
  const pts = clean
    .map((v, i) => `${(i * step).toFixed(2)},${(height - ((v - min) / range) * height).toFixed(2)}`)
    .join(" ");
  return (
    <svg width={width} height={height} className="sparkline-wrap">
      <polyline points={pts} fill={fill} stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
